import React from 'react';
import styles from '../card.scss';

const SkeletonCard = () => (
  <div className="card card-rounded pad-responsive stack pad-4-tb margin-2-t o-media__body">
    <div className={`${styles.oVerticalSpacing}`}>
      <h3 className={`${styles.cardBody__headline}`}>
        <span className={`${styles.skeletonBox}`} style={{ width: '55%' }} />
      </h3>
      <p>
        <span className={`${styles.skeletonBox}`} style={{ width: '80%' }} />
        <span className={`${styles.skeletonBox}`} style={{ width: '90%' }} />
        <span className={`${styles.skeletonBox}`} style={{ width: '83%' }} />
        <span className={`${styles.skeletonBox}`} style={{ width: '60%' }} />
        <span className={`${styles.skeletonBox}`} style={{ width: '70%' }} />
        <span className={`${styles.skeletonBox}`} style={{ width: '50%' }} />
        <span className={`${styles.skeletonBox}`} style={{ width: '83%' }} />
        <span className={`${styles.skeletonBox}`} style={{ width: '80%' }} />
      </p>
      <div className={`${styles.cardBody__meta}`}>
        <span className={`${styles.skeletonBox}`} style={{ width: '70px' }} />
      </div>
    </div>
  </div>
);

export default SkeletonCard;
